module.exports = __webpack_public_path__ + "img/11.9b8c7f4c.png";